<template>
  <!-- 批评通报审核 -->
  <div class="check_situation">
    <div class="accident">
      <div class="tip">受处理类型</div>
      <div class="drop_down" @click="showQuarter">
        <span v-if="!selectQuarter.text">请选择</span>
        <span class="selected" v-if="selectQuarter.text">{{selectQuarter.text}}</span>
        <img src="@/assets/appraise/arrow_right.png" alt />
      </div>
    </div>
    <div class="accident">
      <div class="tip">审核扣分</div>
      <div class="input">
        <input
          type="text"
          @input="handleScoreInput($event)"
          v-model="deductScore"
          placeholder="请输入"
        />
      </div>
    </div>
    <div class="reason">
      <div class="reason_tit">受处理原因</div>
      <div class="content">
        <!-- <van-field
          v-model="deducReason"
          rows="6"
          autosize
          autofocus
          type="textarea"
          maxlength="1000"
          placeholder="请输入扣分原因"
          show-word-limit
        />-->
        <div class="about_content">
          <textarea
            class="content"
            placeholder="请输入受处理原因"
            maxlength="1000"
            v-model="deducReason"
            @input="change"
          ></textarea>
          <span class="total">{{currentTotal}}/1000</span>
        </div>
      </div>
    </div>
    <div class="btn">
      <van-button @click="submit" type="primary" size="large">提交</van-button>
    </div>
    <confirmDialog
      v-if="showDialog"
      :title="dialogTitle"
      :content="dialogContent"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></confirmDialog>
    <commonPicker
      ref="commonPickerQuarter"
      :typeList="newQuarterList"
      :title="title"
      :cols="cols1"
      @getTypeValue="getTypeValue"
    ></commonPicker>
    <tipDialog :isShow="showTips" :content="requireCont" @closeModal="showTips=false"></tipDialog>
  </div>
</template>

<script>
import confirmDialog from "../components/confirmDialog.vue";
import commonPicker from "../../../components/base/myCommonPicker.vue";
import tipDialog from "../travelNegative/components/tipDialog.vue";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
import api from "@/service/modules/appraiseNew.js";
export default {
  components: {
    confirmDialog,
    commonPicker,
    tipDialog,
  },
  data() {
    return {
      showDialog: false,
      showTips: false,
      requireCont: "",
      dialogTitle: "",
      dialogContent: "请确认该州（市）数据及扣分准确无误",
      cancelBtn: "",
      confirmBtn: "",
      deductScore: 1, // 扣分数
      deducReason: "", // 扣分原因
      selectQuarter: {},
      currentTotal: 0,
      newQuarterList: [],
      // newQuarterList: [
      //   [
      //     { id: "E1", text: "受到通报批评" },
      //     { id: "E2", text: "受到约谈问责" },
      //     { id: "E3", text: "涉旅企业警告、整改、取消等级" },
      //   ],
      // ],
      cols1: 1,
      title: "",
      //权限字段
      accidentListAuth: this.$route.query.accidentListAuth,
      meetListAuth: this.$route.query.meetListAuth,
      abarbeitungListAuth: this.$route.query.abarbeitungListAuth
    };
  },
  created() {
    const initNotify = [
      { id: "E1", text: "受到通报批评" },
      { id: "E2", text: "受到约谈问责" },
      { id: "E3", text: "涉旅企业警告、整改、取消等级" } 
    ];
    let temArr = [];
    for (let i = 0; i < initNotify.length; i++) { 
      if (initNotify[i].id === this.accidentListAuth) {
        temArr.push(initNotify[i]);
      }
      if (initNotify[i].id === this.meetListAuth) {
        temArr.push(initNotify[i]);
      }
      if (initNotify[i].id === this.abarbeitungListAuth) {
        temArr.push(initNotify[i]);
      }
    }
    this.newQuarterList.push(temArr)
    this.queryDetail();
  },
  methods: {
    // 获取详情内容
    queryDetail() {
      let params = {
        id: this.$route.query.id,
      };
      api.getNoticeDetail(params).then((res) => {
        if (res.ret === 0) {
          // this.deductScore = (res.data.deduction / 100).toFixed(1);
          this.selectQuarter = this.newQuarterList[0].filter((item) => {
            return item.id === res.data.punishType;
          })[0];
        }
      });
    },
    change() {
      this.currentTotal = this.deducReason.trim().length;
    },
    handleScoreInput(event) {
      const newValue = (event.currentTarget || event.target).value;
      if (Number(newValue) > 10) {
        this.deductScore = 1;
        return false;
      }
      let a = newValue
        .replace(/[^\d.]/g, "")
        .replace(/\.{2,}/g, ".")
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
        .replace(/^\./g, "");
      this.deductScore = a;
    },
    // 提交
    submit() {
      // if(!(/(^[0-9]\d*$)/.test(this.deductScore))) {
      //     this.requireCont = '请输入正整数';
      //     this.showTips = true;
      //     return;
      //   }
      if (!Number(this.deductScore)) {
        this.requireCont = "请输入扣分分数";
        this.showTips = true;
        return;
      }
      if (this.deductScore > 10) {
        this.requireCont = "请输入≤10分";
        this.showTips = true;
        return;
      }
      if (this.deducReason == "") {
        this.requireCont = "请填写“受处理原因”";
        this.showTips = true;
        return;
      }
      (this.dialogTitle = "是否提交"),
        (this.cancelBtn = "取消"),
        (this.confirmBtn = "提交"),
        (this.showDialog = true);
    },
    // 弹窗确认回调
    confirm() {
      const { area, year, quarter } = this.$route.query;
      this.showDialog = false;
      let data = {
        id: this.$route.query.id,
        deduction: this.deductScore * 100,
        punishReason: this.deducReason,
        punishType: this.selectQuarter.id,
      };
      api.leaderNoticeAudit(data).then((res) => {
        if (res.ret === 0) {
          this.$Toast({
            message: "审核成功",
            icon,
          });
          setTimeout(() => {
            this.$router.back(-1);
          }, 2000);
        }
      });
    },
    // 弹窗失败回调
    cancel() {
      this.showDialog = false;
    },
    showQuarter() {
      // 唤起类型选择组件
      this.$refs.commonPickerQuarter.showPicker();
    },
    // 受处理类型回调
    getTypeValue(value) {
      this.selectQuarter = value[0];
    },
  },
};
</script>

<style scoped lang="less">
.check_situation {
  padding: 9px 12px 0;
}
.accident {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  height: 46px;
  border-bottom: 1px solid #ededed;
  .tip {
    color: #666;
    font-size: 14px;
  }
  .input input {
    text-align: right;
  }
  .input input::-webkit-input-placeholder {
    font-size: 14px;
    color: #ccc;
    text-align: right;
  }
  .drop_down {
    span {
      margin-right: 4px;
      color: #ccc;
      font-size: 14px;
    }
    img {
      display: inline-block;
      width: 12px;
      height: 12px;
      vertical-align: text-top;
    }
    span.selected {
      color: #333;
      font-size: 14px;
    }
  }
  .score {
    color: #666;
    font-size: 14px;
  }
}
.reason {
  .reason_tit {
    padding: 16px 0 12px;
    color: #666;
    font-size: 14px;
  }
  .content {
    overflow: hidden;
    .van-field {
      padding: 16px 12px 28px 12px;
      height: 180px;
      background-color: #f5f5f5;
    }
    /deep/ .van-field__body {
      height: 130px;
      overflow: auto;
      // padding: 3px 0 0 0;
      // margin-top: -3px;
      .textarea {
        height: 130px;
      }
    }
    /deep/ .van-field__word-limit {
      font-size: 14px;
      color: #333;
      span {
        color: #999;
      }
    }
  }
}
.btn {
  margin-top: 16px;
  ::v-deep .van-button {
    width: 351px;
    height: 40px;
    background-color: #36b374;
  }
}
.about_content {
  width: 100%;
  position: relative;
  .content {
    width: 100%;
    height: 180px;
    font-size: 14px;
    color: #323233;
    background-color: #f5f5f5;
    border: 0;
    outline: none;
    border-radius: 3px;
    padding: 16px;
    box-sizing: border-box;
    line-height: 1.3em;
    overflow: auto;
  }
  .total {
    position: absolute;
    bottom: 8px;
    right: 8px;
    font-size: 14px;
    color: #323233;
  }
}
</style>